'use client';

import { useEffect, useState } from 'react';
import { useQueryParam } from '@/hooks/use-query-param';
import CheckboxGroup from '@/components/ui/checkbox-group';
import { useSearchParams } from 'next/navigation';

const categories = [
  { id: 'cat-1', label: 'Office', checked: false },
  { id: 'cat-2', label: 'PopUp Shop', checked: false },
  { id: 'cat-3', label: 'Parking Lot', checked: false },
  { id: 'cat-4', label: 'Vacant Land', checked: false },
  { id: 'cat-5', label: 'Warehouse', checked: false },
];

interface ItemProps {
  id: string;
  label: string;
  checked: boolean;
}

export default function CategoryFilter() {
  const searchParams = useSearchParams();
  const manf = searchParams?.get('category');
  const [selected, setSelected] = useState<ItemProps[]>(categories);
  const { updateQueryparams } = useQueryParam();

  const handleInputChange = (item: ItemProps) => {
    setSelected((prev) =>
      prev.map((elem) =>
        elem.id === item.id ? { ...elem, checked: !elem.checked } : elem,
      ),
    );
  };

  // if initial query
  useEffect(() => {
    let m = manf?.split(',');
    const updatedItems = [...selected];
    updatedItems.map((elem) => {
      if (m?.includes(elem.label)) elem.checked = true;
    });
    setSelected(updatedItems);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // updates query
  useEffect(() => {
    const checkedItems = [];
    for (const item of selected) {
      if (item.checked) checkedItems.push(item.label);
    }
    updateQueryparams('category', checkedItems.toString());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selected]);

  // reset
  useEffect(() => {
    if (!manf) {
      const updatedItems = [...selected];
      updatedItems.map((elem) => (elem.checked = false));
      setSelected(updatedItems);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [manf]);

  return (
    <CheckboxGroup
      label="Select Business Type"
      labelClassName="!text-sm lg:!text-base mb-4 lg:mb-2"
      data={selected}
      onChange={(item) => handleInputChange(item)}
    />
  );
}
